import { components } from 'type/ReportServiceSchema';

export type TrendRelativeScoreDto = components['schemas']['TrendRelativeScore'];

export type TrendRelativeScoreModel = {
  diff?: number | null;
  label: string;
};

export const mapTrendRelativeScoreDtoToModel = (
  dto: TrendRelativeScoreDto
): TrendRelativeScoreModel => ({
  diff: dto.diff,
  label: dto.label,
});
